import { Link } from "react-router-dom";
import { Phone, Mail, Clock, MapPin, Facebook } from "lucide-react";
import { SITE } from "@/constants/site";
import { scrollToId } from "@/lib/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-seam bg-ink">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-20 md:px-10">
      <p
        aria-hidden="true"
        className="text-outline pointer-events-none select-none whitespace-nowrap font-display text-[13vw] font-black italic uppercase leading-[0.8] tracking-tighter"
      >
        Take The Leap
      </p>

      <div className="mt-16 grid gap-12 border-t border-seam pt-12 md:grid-cols-4">
        <div>
          <p className="font-display text-xl font-black italic uppercase tracking-tight">
            Take The <span className="text-acid">Leap</span>
          </p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-zinc-500">
            {SITE.tagline} Same-day junk removal with upfront pricing and zero lifting on your end.
          </p>
        </div>
        <div>
          <p className="mb-4 text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-500">Contact</p>
          <a data-testid="footer-call-link" href={`tel:${SITE.phoneTel}`} className="flex items-center gap-2 text-sm font-semibold text-white transition-colors duration-200 hover:text-acid">
            <Phone className="h-4 w-4 text-acid" /> {SITE.phoneDisplay}
          </a>
          <a data-testid="footer-email-link" href={`mailto:${SITE.email}`} className="mt-3 flex items-center gap-2 text-sm font-semibold text-white transition-colors duration-200 hover:text-acid">
            <Mail className="h-4 w-4 text-acid" /> {SITE.email}
          </a>
          <a data-testid="footer-facebook-link" href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" className="mt-3 flex items-center gap-2 text-sm font-semibold text-white transition-colors duration-200 hover:text-acid">
            <Facebook className="h-4 w-4 text-acid" /> Follow us on Facebook
          </a>
        </div>
        <div>
          <p className="mb-4 text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-500">Hours & Area</p>
          <p className="flex items-center gap-2 text-sm text-zinc-300">
            <Clock className="h-4 w-4 text-acid" /> {SITE.hours}
          </p>
          <p className="mt-3 flex items-center gap-2 text-sm text-zinc-300">
            <MapPin className="h-4 w-4 text-acid" /> {SITE.area}
          </p>
        </div>
        <div>
          <p className="mb-4 text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-500">Quick links</p>
          <div className="flex flex-col gap-3">
            <button data-testid="footer-services-link" onClick={() => scrollToId("services")} className="w-fit text-sm text-zinc-300 transition-colors duration-200 hover:text-acid">Services</button>
            <button data-testid="footer-pricing-link" onClick={() => scrollToId("pricing")} className="w-fit text-sm text-zinc-300 transition-colors duration-200 hover:text-acid">Pricing</button>
            <button data-testid="footer-quote-link" onClick={() => scrollToId("quote")} className="w-fit text-sm text-zinc-300 transition-colors duration-200 hover:text-acid">Free quote</button>
            <Link data-testid="footer-areas-link" to="/service-areas" className="w-fit text-sm text-zinc-300 transition-colors duration-200 hover:text-acid">Service areas</Link>
            <a data-testid="footer-review-link" href={SITE.googleReviewUrl} target="_blank" rel="noopener noreferrer" className="w-fit text-sm text-zinc-300 transition-colors duration-200 hover:text-acid">Review us on Google</a>
            <Link data-testid="footer-legal-link" to="/legal" className="w-fit text-sm text-zinc-300 transition-colors duration-200 hover:text-acid">Terms & privacy</Link>
            <Link data-testid="footer-admin-link" to="/admin/login" className="w-fit text-sm text-zinc-500 transition-colors duration-200 hover:text-acid">
              Owner login
            </Link>
          </div>
        </div>
      </div>

      <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-seam pt-8">
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} Take The Leap Junk Removal LLC. All rights reserved.</p>
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-zinc-700">
          We take the junk. <span className="text-acid">You start fresh.</span>
        </p>
      </div>
    </div>
  </footer>
);
